import { Controller } from "@hotwired/stimulus"

// 送信に時間がかかるフォーム（求人票のAI読み取りなど）で、送信中であることを示して二重送信を防ぐ。
// Turbo を使わないネイティブ送信のフォーム向け（Turbo なら data-turbo-submits-with で足りる）。
export default class extends Controller {
  static targets = ["button"]
  static values = { label: String }

  submit() {
    this.buttonTargets.forEach((button) => {
      button.value = this.labelValue
      // submit ハンドラの中で同期的に無効化すると、送信自体をキャンセルするブラウザがあるため、
      // 送信が始まった次のタイミングで無効化する。
      setTimeout(() => {
        button.disabled = true
      }, 0)
    })
  }
}
